
// document.addEventListener("DOMContentLoaded", function () {
//     function attachAddToCartEvents() {
//         document.querySelectorAll(".add-to-cart-form").forEach(form => {
//             if (!form.hasAttribute("data-event-attached")) { // ✅ Prevent duplicate event listeners
//                 form.setAttribute("data-event-attached", "true");

//                 form.addEventListener("submit", function (event) {
//                     event.preventDefault(); // ✅ Prevent Page Reload

//                     let button = this.querySelector("button");
//                     let productId = this.dataset.productId;
//                     let formData = { id: productId, quantity: 1 };

//                     //console.log(`🛒 Adding product ${productId} to cart...`);

//                     // ✅ Show loading state
//                     button.classList.add("loading");
//                     button.disabled = true;

//                     fetch('/cart/add.js', {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(formData)
//                     })
//                     .then(response => response.json())
//                     .then(data => {
//                         //console.log("✅ Product Added to Cart:", data);

//                         // ✅ Remove loading state
//                         button.classList.remove("loading");
//                         button.disabled = false;

//                         // ✅ Update cart count
//                         updateCartCount();

//                         // ✅ Show success message
//                         showMessage("Item added to cart successfully!", "success");
//                     })
//                     .catch(error => {
//                         console.error("❌ Error adding to cart:", error);
//                         showMessage("Error adding item to cart.", "error");

//                         // ✅ Remove loading state
//                         button.classList.remove("loading");
//                         button.disabled = false;
//                     });
//                 });
//             }
//         });
//     }

//     // ✅ Function to Update Cart Count
//     function updateCartCount() {
//         fetch('/cart.js')
//         .then(response => response.json())
//         .then(cartData => {
//             let cartCount = document.querySelector(".cart-count");
//             if (cartCount) {
//                 cartCount.textContent = cartData.item_count; // ✅ Update count dynamically
//             }
//         });
//     }

//     // ✅ Function to Show Message (Optional)
//     function showMessage(message, type) {
//         let messageBox = document.createElement("div");
//         messageBox.textContent = message;
//         messageBox.classList.add("cart-message", type);
//         document.body.appendChild(messageBox);

//         setTimeout(() => {
//             messageBox.remove();
//         }, 3000);
//     }

//     // ✅ Ensure JavaScript Re-Attaches When Related Products Load
//     let observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//             if (mutation.addedNodes.length > 0) {
//                 console.log("🔄 Related Products Loaded. Reattaching Add to Cart Events...");
//                 attachAddToCartEvents(); // ✅ Reapply event listeners dynamically
//             }
//         });
//     });

//     let relatedProductsContainer = document.querySelector(".related-products");
//     if (relatedProductsContainer) {
//         observer.observe(relatedProductsContainer, { childList: true, subtree: true });
//     }

//     // ✅ Run the function to attach event listeners on page load
//     attachAddToCartEvents();
// });
// --------------------------------others page add to card button script-----------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
    function attachAddToCartEvents() {
        document.querySelectorAll(".add-to-cart-form").forEach(form => {
            if (!form.hasAttribute("data-event-attached")) { // ✅ Prevent duplicate event listeners
                form.setAttribute("data-event-attached", "true");

                form.addEventListener("submit", function (event) {
                    event.preventDefault(); // ✅ Prevent Page Reload

                    let button = this.querySelector("button");
                    let productId = this.dataset.productId;
                    let formData = { id: productId, quantity: 1 };

                    // ✅ Show loading state
                    button.classList.add("loading");
                    button.disabled = true;

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // ✅ Remove loading state
                        button.classList.remove("loading");
                        button.disabled = false;

                        // ✅ Update cart count
                        updateCartCount();

                        // ✅ Show success message
                        showMessage("Item added to cart successfully!", "success");
                    })
                    .catch(error => {
                        console.error("❌ Error adding to cart:", error);
                        showMessage("Error adding item to cart.", "error");

                        // ✅ Remove loading state
                        button.classList.remove("loading");
                        button.disabled = false;
                    });
                });
            }
        });
    }

    // ✅ Function to Update Cart Count
    function updateCartCount() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
            let cartCount = document.querySelector(".cart-count");
            if (cartCount) {
                cartCount.textContent = cartData.item_count; // ✅ Update count dynamically
            }
        });
    }

    // ✅ Function to Show Message (Optional)
    function showMessage(message, type) {
        let messageBox = document.createElement("div");
        messageBox.textContent = message;
        messageBox.classList.add("cart-message", type);
        document.body.appendChild(messageBox);

        setTimeout(() => {
            messageBox.remove();
        }, 3000);
    }

    // ✅ Load More Button Functionality (Fix Added)
    const loadMoreButton = document.getElementById("load-more");
    const productContainer = document.getElementById("filtered-products");
    let currentPage = 1;
    let totalPages = parseInt(loadMoreButton?.getAttribute("data-total-pages") || 1);

    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", function () {
            if (currentPage >= totalPages) {
                loadMoreButton.style.display = "none";
                return;
            }

            currentPage++;
            loadMoreButton.classList.add("loading"); // Show loading effect

            fetch(`${window.location.pathname}?page=${currentPage}`)
                .then(response => response.text())
                .then(data => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(data, "text/html");
                    let newProducts = doc.querySelector("#filtered-products").innerHTML;

                    productContainer.insertAdjacentHTML("beforeend", newProducts);
                    loadMoreButton.classList.remove("loading"); // Remove loading effect

                    if (currentPage >= totalPages) {
                        loadMoreButton.style.display = "none"; // Hide button if all products are loaded
                    }

                    // ✅ Reattach Add to Cart Event Listeners After Load More
                    attachAddToCartEvents();
                })
                .catch(error => {
                    console.error("Error loading more products:", error);
                    loadMoreButton.classList.remove("loading");
                });
        });
    }

    // ✅ Ensure JavaScript Re-Attaches When Related Products Load
    let observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length > 0) {
                console.log("🔄 Related Products Loaded. Reattaching Add to Cart Events...");
                attachAddToCartEvents(); // ✅ Reapply event listeners dynamically
            }
        });
    });

    let relatedProductsContainer = document.querySelector(".related-products");
    if (relatedProductsContainer) {
        observer.observe(relatedProductsContainer, { childList: true, subtree: true });
    }

    // ✅ Run the function to attach event listeners on page load
    attachAddToCartEvents();
});
// --------------------------------others page add to card button script-----------------------------------------------


 
// Function to Show Success/Error Message
function showMessage(message, type) {
   let msgDiv = document.createElement("div");
   msgDiv.textContent = message;
   msgDiv.className = `cart-message ${type} fade-in`;
   document.body.appendChild(msgDiv);
   // Remove message after 3 seconds
   setTimeout(() => {
       msgDiv.classList.add("fade-out"); 
        setTimeout(() => {
            msgDiv.remove();
        }, 300);
   }, 3000);
}

// navigation menu script
// Get the header area and mobile menu area elements
const headerArea = document.querySelector('.header-area');
const mobileMenuArea = document.querySelector('.mobile-menu-area');
const menuToggle = document.querySelector('.menu-toggle');
const mobileNavigation = document.querySelector('.mobile-navigation');
const bodyOverlay = document.querySelector('body');
function adjustMobileMenuPosition() {
    const headerHeight = headerArea.offsetHeight;
    mobileMenuArea.style.top = `${headerHeight}px`;
    mobileMenuArea.style.height = `calc(100vh - ${headerHeight}px)`;
}
adjustMobileMenuPosition();
window.addEventListener('resize', adjustMobileMenuPosition);


// Function to toggle 
function toggleMenu() {
    menuToggle.classList.toggle('active');
    mobileMenuArea.classList.toggle('active');
    bodyOverlay.classList.toggle('overflow__hidden');
    
}
// Function to close menu 
function closeMenu(event) {
    if (!menuToggle.contains(event.target) && !mobileNavigation.contains(event.target)) {
        menuToggle.classList.remove('active');
        mobileMenuArea.classList.remove('active');
    }
}
menuToggle.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleMenu();
});
document.body.addEventListener('click', closeMenu);
mobileNavigation.addEventListener('click', (e) => {
    e.stopPropagation();
});

const navigationItems = document.querySelectorAll('.navigation-item');
navigationItems.forEach(item => {
    item.querySelector('svg').addEventListener('click', function(e) {
        e.stopPropagation();
        navigationItems.forEach(otherItem => {
            if (otherItem !== item) {
                otherItem.classList.remove('active');
            }
        });
        item.classList.toggle('active');
    });
    menuToggle.addEventListener('click', (e) => {
        item.classList.remove('active');
    });
});
document.body.addEventListener('click', () => {
    navigationItems.forEach(item => {
        item.classList.remove('active');
    });
});


// hero slider script
// Initialize Swiper
const swiperElement = document.querySelector('.hero-slider');

const swiper = new Swiper(swiperElement, {       
    slidesPerView: 1,
    spaceBetween: 40,
    loop: false,
    effect: "fade",
    autoHeight: true,
    autoplay: {
        delay: 3000000, // Reduced from 3000000 to 3 seconds for usability
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return `<span class="${className}">${index + 1}</span>`;
        },
    },
    navigation: false,
    on: {
        init: function () {
            this.slideToLoop(0); 
            updatePagination(this);
        },
        slideChange: function () {
            updatePagination(this);
        }
    }
});
function updatePagination(swiper) {
    // Clear existing pagination bullets inside each slide
    document.querySelectorAll(".swiper-pagination").forEach(pagination => {
        pagination.innerHTML = "";
    });

    // Get the total number of real slides (excluding looped duplicates)
    const totalSlides = swiper.slides.length - swiper.loopedSlides * 2 || swiper.slides.length;

    // Get the currently active slide
    const activeSlide = swiper.slides[swiper.activeIndex];
    const paginationDiv = activeSlide.querySelector(".swiper-pagination");

    if (paginationDiv) {
        for (let i = 0; i < totalSlides; i++) {
            let bullet = document.createElement("span");
            bullet.classList.add("swiper-pagination-bullet");

            // Highlight the active bullet
            if (i === swiper.realIndex) {
                bullet.classList.add("swiper-pagination-bullet-active");
            }

            bullet.style.cursor = "pointer";
            bullet.addEventListener("click", () => swiper.slideToLoop(i));

            paginationDiv.appendChild(bullet);
        }
    }
}



// partners slider animation start here

const partnersElement = document.querySelector('.partners-slider');

const swiperPartners = new Swiper(partnersElement, {       
    slidesPerView: 1, 
    spaceBetween: 100,
    loop: true,
    // autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    // },
    navigation: {
        nextEl: '.partners-next',
        prevEl: '.partners-prev',
    },
    breakpoints: {
        1400: {
            spaceBetween: 60,
            slidesPerView: 5,
        },
        1024: {
            spaceBetween: 40,
            slidesPerView: 4,
        },
        768: {
            spaceBetween: 30,
            slidesPerView: 3
        },
        575: {
            spaceBetween: 30,
            slidesPerView: 2
        }
    }
});

const partnersThumbnailElement = document.querySelector('.partners-thumbnail-slider');

const swiperPartnersThumbnail = new Swiper(partnersThumbnailElement, {       
    slidesPerView: 1, 
    spaceBetween: 30,
    loop: true,
    // centeredSlides: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    breakpoints: {
        1400: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2,
        },
        575: {
            slidesPerView: 2,
        }
    }
});


// Team Slider
const tmSlider = document.querySelector('.tm-slider');
const teamSlider = new Swiper(tmSlider, {       
    slidesPerView: 1, 
    spaceBetween: 20,
    loop: true,
    navigation: {
        nextEl: '.team-next',
        prevEl: '.team-prev',
    },
    breakpoints: {
        1400: {
            spaceBetween: 30,
            slidesPerView: 4,
        },
        1024: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 2
        },
        575: {
            slidesPerView: 1
        }
    }
});


